import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { StudentService } from '../shared/student.service';
import { Admin } from 'src/app/shared/admin.module';

@Component({
  selector: 'app-students',
  templateUrl: './students.component.html',
  styleUrls: ['./students.component.css']
})
export class StudentsComponent implements OnInit {

  constructor(private fireStore: AngularFirestore, private service: StudentService) { }
  list: Admin[];
  admin = new Admin();

  ngOnInit() {
    this.admin.active = true;
    this.service.getAdminCollection().subscribe(response => {
      this.list = response.map(document => {
        return {
          id: document.payload.doc.id,
          ...document.payload.doc.data() as {}    // Attention - Require typescript version >3 to work!!
        } as Admin;
      })
      this.admin = this.list[0];
    });
  }

  updateActive() {
    this.fireStore.doc('admin/' + this.admin.id).update(this.admin);
  }

}
